import React from "react";

import { useQuery } from "@apollo/client";

// @ts-ignore
import {
  // createStyles,
  // makeStyles,
  // Theme,
  ThemeProvider,
} from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemText from "@material-ui/core/ListItemText";

import { SERVER_URI } from "../../constants";

import panelCollectionMiniQuery from "./panel-collection-mini-query";

import LiveDataTable from "./livedata-table-mui";

import { theme as smallTableTheme } from "../../small-table-theme";

// const useStyles = makeStyles((theme: Theme) => createStyles({}));

interface Props {
  // nodes: any[];
  // widgetStatic?: boolean;
  // widgetTitle?: string;
  node: any;
  panelCollectionName: string;
}

function LiveDataMapMiniPanel(props: Props) {
  // const classes = useStyles(props);
  const { node, panelCollectionName } = props;

  const { data, error, loading } = useQuery(panelCollectionMiniQuery, {
    variables: {
      panelCollectionName: panelCollectionName,
      node: node.id,
    },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }

  return (
    <ThemeProvider theme={smallTableTheme}>
      <Grid container>
        <Grid
          item
          xs={6}
          md={6}
          container
          justify="center"
          alignItems="flex-start"
        >
          <img
            src={`${SERVER_URI}${data.iconLink.iconLink}`}
            style={{ maxWidth: "140px" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <LiveDataTable
            metaData={data.table}
            // leftColumns={["index_0"]} // TODO naming
            tableColumnExtensions={[
              { columnName: "index_0", align: "left", width: 64 },
              // ...data.table.columns.map((column: any, columnIndex: any) => ({
              //   columnName: column.headerData.content || `index_${columnIndex}`,
              //   align: "right",
              // })),
            ]}
          />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default LiveDataMapMiniPanel;
